import { render, staticRenderFns } from "./AddNote.vue?vue&type=template&id=134419e5&scoped=true"
import script from "./AddNote.vue?vue&type=script&lang=js"
export * from "./AddNote.vue?vue&type=script&lang=js"
import style0 from "./AddNote.vue?vue&type=style&index=0&id=134419e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134419e5",
  null
  
)

export default component.exports